import {generateClient, GraphQLResult} from 'aws-amplify/api';
import {ILevelsRepository} from './ILevelsRepository';
import {levels} from './LevelsQueries';
import {Amplify} from 'aws-amplify';
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  LevelService as PikadoLevelService,
} from '@PikaDoApp/npm-pikado-logic';
import {getEnvironment} from '../../lib/getEnvironment';

// Initialize the Pikado Logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

const client = generateClient();
const pikadoLevelService = new PikadoLevelService();
export class LevelsRepository implements ILevelsRepository {
  async getLevels(): Promise<any> {
    try {
      // OLD IMPLEMENTATION - COMMENTED OUT (using GraphQL directly)
      // const response: GraphQLResult<any> = await client.graphql({
      //   query: levels,
      //   variables: {},
      // });
      // //console.log('Levels->', response);
      // return response.data?.levels.items;

      // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
      const levels = await pikadoLevelService.getNewLevels();

      if (!levels) {
        return [];
      }

      // Transform NewLevel[] to match old Level structure
      // Map _id to id for UI compatibility
      // Add score and number as null (not in new schema)
      // Note: NewLevel type doesn't have createdAt/updatedAt, generating timestamps
      const transformedLevels = levels.map(level => ({
        id: level._id,           // Map _id to id
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        name: level.name,
        score: null,             // Not in new schema
        number: null,  
        oldId:level.oldId          // Not in new schema
      }));

      return transformedLevels;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] getLevels repository Error:', error);
      throw new Error(error);
    }
  }

  async getNewLevels(): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const levels = await pikadoLevelService.getNewLevels();

      if (!levels) {
        return [];
      }

      // Transform NewLevel[] to match old Level structure
      // Map _id to id for UI compatibility
      // Add score and number as null (not in new schema)
      // Note: NewLevel type doesn't have createdAt/updatedAt, generating timestamps
      const transformedLevels = levels.map(level => ({
        id: level._id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        name: level.name,
        score: null,
        number: null,
      }));

      return transformedLevels;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] getNewLevels repository Error:', error);
      throw new Error(error);
    }
  }

  async getNewLevelById(id: string): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const level = await pikadoLevelService.getNewLevelById(id);

      if (!level) {
        return null;
      }

      // Transform NewLevel to match old Level structure
      // Map _id to id for UI compatibility
      // Add score and number as null (not in new schema)
      // Note: NewLevel type doesn't have createdAt/updatedAt, generating timestamps
      const transformedLevel = {
        id: level._id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        name: level.name,
        oldId:level.oldId,
        score: null,
        number: null,
      };

      return transformedLevel;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] getNewLevelById repository Error:', error);
      throw new Error(error);
    }
  }

  async createNewLevel(input: any): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const createdLevel = await pikadoLevelService.createNewLevel(input);

      if (!createdLevel) {
        return null;
      }

      // Transform CreatedNewLevel to match old Level structure
      // Note: CreatedNewLevel type doesn't have createdAt/updatedAt, generating timestamps
      const transformedLevel = {
        id: createdLevel._id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        name: createdLevel.name,
        score: null,
        number: null,
      };

      return transformedLevel;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] createNewLevel repository Error:', error);
      throw new Error(error);
    }
  }

  async updateNewLevel(input: any): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const updatedLevel = await pikadoLevelService.updateNewLevel(input);

      if (!updatedLevel) {
        return null;
      }

      // Transform UpdatedNewLevel to match old Level structure
      // Note: UpdatedNewLevel type doesn't have createdAt/updatedAt, generating timestamps
      const transformedLevel = {
        id: updatedLevel._id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        name: updatedLevel.name,
        score: null,
        number: null,
      };

      return transformedLevel;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] updateNewLevel repository Error:', error);
      throw new Error(error);
    }
  }

  async deleteNewLevel(id: string): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const result = await pikadoLevelService.softDeleteNewLevel(id);
      return result;
    } catch (error) {
      console.error('🔍 [LEVEL-NEW-PACKAGE] deleteNewLevel repository Error:', error);
      throw new Error(error);
    }
  }
}
